import React, { PropTypes, PureComponent } from 'react';
import { Modal, InverseButton } from 'react-fast-ui';

export default class AdminBracketActionModal extends PureComponent {
  render() {
    const { open, onClose, onSelect } = this.props;
    return (
      <Modal open={open} onClose={onClose} size="xs">
        <Modal.Title onClose={onClose}> Select Action</Modal.Title>
        <Modal.Body className="mg-md">
          <div className="lg-font text-center"> What would you like to do with this Game?</div>
          <div className="height-100 display-flex justify-content-center align-items-center">
            <InverseButton onClick={() => onSelect({ editingGame: true })} className="mg-sm">
              <span className="pd-md"> Edit Game </span>
            </InverseButton>
            <InverseButton onClick={() => onSelect({ editingScore: true })} className="mg-sm">
              <span className="pd-md"> Edit Score </span>
            </InverseButton>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/modals/AdminBracketActionModal.jsx